module.exports = __webpack_public_path__ + "img/amazon-icon.819afb57.svg";